import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./SignUp.css";
import { useNavigate } from "react-router-dom";
import Header from "../../components/layout/header";
import { toast } from "react-toastify";
import axios from "axios";
import { BASE_URL } from "../../constant";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

const SignUp = () => {
  const navigate = useNavigate();
  const [Name, SetName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setconfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isChecked, setIsChecked] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);

  const validateForm = () => {
    const errors = {};
    //checking for name
    if (!Name.trim()) {
      errors.Name = "Please enter Name";
    } else if (!/^[A-Za-z\s]+$/.test(Name)) {
      errors.Name = "Name should only contain letters";
    }
    // Check if email is empty or not valid
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Please enter a valid email address";
    }
    //check if Mobile number empty
    if (!mobileNumber.trim()) {
      errors.mobileNumber = "Mobile number is required";
    } else if (!/^\d{10}$/.test(mobileNumber)) {
      errors.mobileNumber = "Mobile number should be exactly 10 digits long";
    }

    // Check if password is empty or less than 7 characters
    if (!password.trim() || password.length < 7) {
      errors.password = "Password must be at least 7 characters long";
    }

    if (
      !confirmPassword.trim() ||
      confirmPassword.length < 7 ||
      confirmPassword !== password
    ) {
      errors.confirmPassword = "Passwords do not match";
    }
    //check check box unclicked
    if (!isChecked) {
      errors.isChecked = "Please agree to continue";
    }
    return errors;
  };

  const handleAddUser = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    try {
      // Adding user with email
      const emailResponse = await axios.post(
        `${BASE_URL}/users/addNewUserEmail?name=${Name}&emailId=${email}&password=${password}&mobile=${mobileNumber}`
      );
      console.log(emailResponse);

      const { errorMessage } = emailResponse.data;
      if (errorMessage) {
        toast.error(errorMessage);
      } else {
        toast.success("User added successfully!");
        navigate("/login");
      }
    } catch (error) {
      console.error(error.response);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="signup-page">
      <Header />
      <div className="signup-email-form-container">
        <form className="signup-email-form">
          <h2 className="signup-email-title">Sign up with Email</h2>
          {errors.Name && <p className="error-message">{errors.Name}</p>}
          <input
            type="text"
            placeholder="Full Name"
            name="Name"
            value={Name}
            onChange={(e) => {
              const newValue = e.target.value.replace(/[^A-Za-z\s]/g, "");
              SetName(newValue);
            }}
            className="signup-name-input"
          />

          {errors.email && <p className="error-message">{errors.email}</p>}
          <input
            type="email"
            placeholder="Email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="signup-email-input"
          />

          {errors.mobileNumber && (
            <p className="error-message">{errors.mobileNumber}</p>
          )}
          <input
            type="number"
            placeholder="Mobile Number"
            className="signup-email-input"
            value={mobileNumber}
            onChange={(e) => {
              const newValue = e.target.value.replace(/[^0-9]/g, "");
              setMobileNumber(newValue);
            }}
          />

          {errors.password && (
            <p className="error-message">{errors.password}</p>
          )}
          <div style={{ position: "relative", cursor: "pointer" }}>
            <input
              type={isPasswordVisible ? "text" : "password"}
              placeholder="Password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="signup-email-input"
            />
            <div
              style={{ position: "absolute", right: "3%", top: "28%" }}
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
            >
              {isPasswordVisible ? (
                <IoMdEye size={20} />
              ) : (
                <IoMdEyeOff size={20} />
              )}
            </div>
          </div>

          <span className="input-hint">Minimum 7 characters</span>

          {errors.confirmPassword && (
            <p className="error-message">{errors.confirmPassword}</p>
          )}
          <div style={{ position: "relative", cursor: "pointer" }}>
            <input
              type={isConfirmPasswordVisible ? "text" : "password"}
              placeholder="Confirm Password"
              name="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setconfirmPassword(e.target.value)}
              className="signup-email-input"
            />
            <div
              style={{ position: "absolute", right: "3%", top: "28%" }}
              onClick={() =>
                setIsConfirmPasswordVisible(!isConfirmPasswordVisible)
              }
            >
              {isConfirmPasswordVisible ? (
                <IoMdEye size={20} />
              ) : (
                <IoMdEyeOff size={20} />
              )}
            </div>
          </div>

          <p>
            {errors.isChecked && (
              <p className="error-message"> {errors.isChecked} </p>
            )}
            <input
              type="checkbox"
              value={isChecked}
              style={{ marginRight: "5px", cursor: "pointer" }}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            By continuing, I agree to the{" "}
            <span>
              <Link to="/terms-of-use" className="signup-highlight">
                Terms Of Use
              </Link>
            </span>{" "}
            and{" "}
            <span>
              <Link to="/privacy-policy" className="signup-highlight">
                Privacy Policy
              </Link>
            </span>
          </p>

          <button className="signup-email-button" onClick={handleAddUser}>
            CONTINUE
          </button>
          <p className="signup-help">
            Having trouble logging in?{" "}
            <span>
              <Link to="/contact" className="signup-help-highlight">
                Get Help
              </Link>
            </span>
          </p>
          <p className="login-help">
            Already have an account?{" "}
            <Link to="/login" className="login-help-highlight">
              Login
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
